<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="closeModal">
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-title-container">
          <div class="modal-divider"></div>
        </div>
        <div class="modal-title">
          <span>{{ modalTitle }}</span>
        </div>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <button v-if="closeButton" class="close-btn" @click="closeModal">{{ $t('Custom.close') }}</button>
        <button v-if="actionButton" class="action-btn" @click="handleAction">{{ buttonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    modalTitle: {
      type: String,
      default: 'Title'
    },
    actionButton: {
      type: Boolean,
      default: true
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    actionType: {
      type: String,
      default: 'create'
    }
  },
  computed: {
    buttonText() {
      return this.actionType === 'create' ? 'Create' : this.actionType;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
      document.body.style.overflow = ''; 
    },
    handleAction() {
      this.$emit('action', this.actionType);
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'; 
      } else {
        document.body.style.overflow = ''; 
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: auto; /* Modal içinde scroll'a izin ver */
}

.modal-container {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  overflow: visible;
  position: relative;
  width: 35%;
  animation: fadeIn 0.3s ease-out;
  padding: 0px 10px;
}

.modal-header {
  display: flex;
  flex-direction: column;
  padding: 25px 15px 5px 15px;
}

.modal-title {
  font-size: 1.25rem;
  color: #333;
}

.modal-title-container {
  display: flex;
  justify-content: center;
}

.modal-divider {
  width: 70px;
  height: 4px;
  background: #ccc;
  border-radius: 2px;
  margin-top: 8px;
  cursor: pointer;
  display: none;
}

.modal-body {
  padding: 10px 20px 10px 20px;
  font-size: 1rem;
  color: #555;
  overflow-y: auto;
  /* max-height: 70vh; */
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px 15px 20px;
}

.action-btn {
  background: var(--background-color);
  color: var(--logo-color);
  border: 1px solid var(--logo-color);
  border-radius: 5px;
  padding: 10px 25px;
  margin-left: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
}

.action-btn:hover {
  background: var(--logo-color);
  color: var(--text-white);
}

.close-btn {
  background: var(--background-color);
  color: var(--red-color);
  border: 1px solid var(--red-color);
  border-radius: 5px;
  padding: 10px 25px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
}

.close-btn:hover {
  background: var(--red-color);
  color: var(--text-white);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .modal-container {
    width: 100%;
    max-width: 100%;
    border-radius: 20px 20px 0 0;
    position: absolute;
    bottom: 0;
    animation: slideUp 0.3s ease-out;
  }

  .modal-divider {
    display: block;
  }

  .modal-header {
    padding: 10px 10px 5px 10px;
  }

  .modal-title {
    display: none;
  }

  .modal-title-container {
    margin-bottom: 5px;
  }

  .modal-body,
  .modal-footer {
    padding: 10px;
  }

  .modal-footer {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .close-btn {
    display: none;
  }

  .action-btn {
    width: 100%;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  .modal-footer {
    justify-content: center;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
</style>